const { getIsFrance } = require("./locale")

const symbols = {
  USD: "$",
  EUR: "€",
  GBP: "£",
}

function getCurrencySymbol(currencyCode) {
  const currencySymbol = symbols[currencyCode]

  if (currencySymbol) {
    return currencySymbol
  }

  return null
}

function formatPrice(price) {
  let parts = price.toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  return parts.join(".")
}

function getLocalisedPrice(price = 0, currencyCode, showDecimal = false) {
  let priceString
  const currencySymbol = getCurrencySymbol(currencyCode)

  price = Number(price)

  if (!(Number.isInteger(price) && !showDecimal)) {
    price = price.toFixed(2) // Adjust the precision as needed
  }

  price = formatPrice(price)

  priceString = currencySymbol + price

  return priceString
}

function getOptionsData(product, isDefault = true) {
  let optionsData = {}

  if (isDefault) {
    let options = product.options

    options.forEach((option) => {
      optionsData[option.name] = option.values[0]
      if (option.values[0].includes("Ring sizer")) {
        optionsData[option.name] = option.values[1]
      }
    })
  } else {
    let selectedOptions = product.selectedOptions

    selectedOptions.forEach((option) => {
      optionsData[option.name] = option.value
    })
  }

  return optionsData
}

function getSelectedVariant(product, optionsData) {
  const productVariants = product.variants
  let selectedVariant = null
  productVariants.forEach((variant) => {
    let selectedOptions = variant.selectedOptions
    let isVariant = false

    for (let i = 0; i < selectedOptions.length; i++) {
      let variantOption = selectedOptions[i]
      let optionName = variantOption.name
      let optionValue = variantOption.value

      if (optionsData[optionName] !== optionValue) {
        isVariant = false

        break
      }

      isVariant = true
    }

    if (isVariant) {
      selectedVariant = variant
    }
  })

  return selectedVariant
}

function getGlobalOutOfStock(tags) {
  const isOutOfStock = tags.find((tag) => tag === "out-of-stock")

  return isOutOfStock
}

function getVariantOutOfStock(tags, color) {
  const isOutOfStock = color
    ? tags.find(
        (tag) => tag.includes(`out-of-stock-${color}`) || tag === "out-of-stock"
      )
    : false

  return isOutOfStock
}

function getVariantPreorderStatus(tags, color) {
  const isPreorderProduct = color
    ? tags.find(
        (tag) => tag.includes(`preorder-${color}`) || tag === "preorder"
      )
    : false

  return isPreorderProduct
}

function getVariantId(variant) {
  let variantId = null

  if (variant.shopifyId) {
    variantId = variant.shopifyId.replace("gid://shopify/ProductVariant/", "")
  }
  return variantId
}

function getPreorderStatus(tags) {
  const isPreorderProduct = tags.find((tag) => tag === "preorder")

  return isPreorderProduct
}

function getProductTags(product, content) {
  let tags = []

  if (product.tags) {
    tags = [...product.tags]
  }

  if (content.tags) {
    tags = [...tags, ...content.tags]
  }

  return Array.from(new Set(tags))
}

function getProductCardContent(product, productContents) {
  const cardProduct = product
  if (product.product_type !== "engagement_ring") {
    const content = productContents.find(
      (content) => content.productHandle?.trim() === product.handle
    )

    if (content) {
      if (content.urlKey) {
        cardProduct.urlKey = content.urlKey
      }

      if (content.startingFrom) {
        cardProduct.startingFrom = content.startingFrom
      }

      cardProduct.tags = getProductTags(product, content)
    }
  }
  return cardProduct
}

function getShippingTime(tags, material) {
  const { handleValue } = material
  const isFrance = getIsFrance()
  const tagString = isFrance ? "shipFr" : "ship"
  const localeString = isFrance
    ? `${handleValue}-shipFr-`
    : `${handleValue}-ship-`
  // const preorderProduct =
  //   getPreorderStatus(tags) ||
  //   getVariantPreorderStatus(tags, material?.handleValue)

  let shippingTime = isFrance ? "7 jours ouvrés" : "7 working days"

  const hasColorShippingTime = tags.some((tag) => tag.includes(localeString))

  if (hasColorShippingTime) {
    const shippingTag = tags.find((tag) => tag.includes(localeString))
    const tagWithoutMaterial = shippingTag.replace(handleValue + "-", "")

    if (shippingTag) {
      shippingTime = `${tagWithoutMaterial.split("-")[1]} ${
        tagWithoutMaterial.split("-")[2]
      }`
    }
  } else {
    const shippingTag = tags.find(
      (tag) => tag.includes(tagString) && tag.split("-")[0] === tagString
    )

    if (shippingTag) {
      shippingTime = `${shippingTag.split("-")[1]} ${shippingTag.split("-")[2]}`
    }
  }

  //Temoprary

  if (tags.includes("holiday-collection")) {
    const holidayInfo = isFrance
      ? "Une seule unité disponible"
      : "only one unit available"
    shippingTime = shippingTime + ` - ${holidayInfo}`
  }

  return shippingTime
}

function getMadeToOrder(tags, material) {
  const { handleValue } = material

  if (tags.includes("preorder")) {
    return true
  }

  const madeToOrder = handleValue
    ? tags.find(
        (tag) =>
          tag.includes(`made-to-order-${handleValue}`) ||
          tag === "made-to-order"
      )
    : false

  return madeToOrder ? true : false
}

function getTagExistence(tagValue, tags, material) {
  const { handleValue } = material

  const status = handleValue
    ? tags.find(
        (tag) => tag.includes(`${tagValue}-${handleValue}`) || tag === tagValue
      )
    : false

  return status ? true : false
}

module.exports = {
  getLocalisedPrice: getLocalisedPrice,
  getOptionsData: getOptionsData,
  getSelectedVariant: getSelectedVariant,
  getGlobalOutOfStock: getGlobalOutOfStock,
  getVariantOutOfStock: getVariantOutOfStock,
  getVariantPreorderStatus: getVariantPreorderStatus,
  getVariantId: getVariantId,
  getPreorderStatus: getPreorderStatus,
  getProductTags: getProductTags,
  getProductCardContent: getProductCardContent,
  getShippingTime: getShippingTime,
  getMadeToOrder: getMadeToOrder,
  getTagExistence: getTagExistence,
}
